import { useQuery } from '@tanstack/react-query'
import { useAxios } from 'packages/core'

export const useUiActionsByResource = (
    resourceId,
    noun = '',
    verb = '',
    isEnabled = true,
) => {
    const callApi = useAxios()

    let endpointUrl = `/api/uiActions/byResourceId?resourceId=${resourceId}`

    if (noun !== '') {
        endpointUrl = `${endpointUrl}&noun=${noun}`
    }
    if (verb !== '') {
        endpointUrl = `${endpointUrl}&verb=${verb}`
    }

    return useQuery(
        ['UI_ACTIONS', resourceId, noun, verb, isEnabled],
        () =>
            callApi({
                method: 'GET',
                url: endpointUrl,
            }).then((data) => data.data),
        {
            enabled: Boolean(resourceId) && isEnabled,
        },
    )
}

export const useAddionalProperties = (
    resourceId,
    resourceTypeId,
    locationId,
    fetchData,
) => {
    const callApi = useAxios()
    return useQuery(
        ['ADDITIONAL_PROPERTIES', resourceId, resourceTypeId, locationId],
        () =>
            callApi({
                method: 'GET',
                url: locationId
                    ? `/api/Application/AdditionalProperties/${resourceId}/${resourceTypeId}?locationId=${locationId}`
                    : `/api/Application/AdditionalProperties/${resourceId}/${resourceTypeId}`,
            }).then((data) => data.data),
        {
            enabled:
                Boolean(resourceId) &&
                Boolean(resourceTypeId) &&
                Boolean(fetchData),
        },
    )
}
